<div class="modal-content">
  <div class="modal-header" #handle>
    <h1 class="title" [translate]="title"></h1>
  </div>
  <div class="modal-body">
    <p [translate]="description"></p>
  </div>
  <div class="modal-footer">
    <div class="is-flex">
      <button type="button" class="mr-1" (click)="close()" fino-button translate>
        approvalModal.abort
      </button>
      <button
        [primary]="true"
        type="button"
        class="ml-1"
        (click)="submit()"
        fino-button
        label="approvalModal.confirm"
      ></button>
    </div>
  </div>
</div>
